<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <label>Descrição</label>
        <input
          type="text"
          class="form-control"
          v-model="description"
          ref="autofocus"
        />
      </div>
      <div class="col-md-12">
        <label>Tipo de centro de custo/lucro</label>
        <div>
          <div class="form-check form-check-inline">
            <input
              @input="handleInputType"
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="parent"
              value="parent"
            />
            <label class="form-check-label" for="parent"
              >Centro de custo/lucro pai</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              @input="handleInputType"
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="daughter"
              value="daughter"
            />
            <label class="form-check-label" for="daughter"
              >Centro de custo/lucro filho</label
            >
          </div>
        </div>
      </div>
      <div v-if="type == 'daughter'" class="col-md-12">
        <label>Centro de custo/lucro pai</label>
        <select v-model="parent_id" class="form-control">
          <option v-for="(item, key) in parents" :value="item.id" :key="key">
            {{ item.description }}
          </option>
        </select>
        <small v-if="parents.length == 0"
          >Não possui centro de custo/lucro pai cadastrado!</small
        >
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <v-btn :disabled="loading" @click="create" class="btn-save">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import { getRestHomeSelectedFinancialAccount } from "../../../../lib/functions";

export default {
  name: "Create",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      description: "",
      type: "",
      parent_id: "",
      parents: [],
      loading: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
    setTimeout(() => this.$refs.autofocus.focus(), 200);
  },
  methods: {
    getRestHomeSelectedFinancialAccount,

    handleInputType() {
      this.parent_id = "";
    },

    retrieve() {
      this.getParents();
    },

    async getParents() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center-all",
          {
            params,
          }
        );

        const { data } = response.data;

        this.parents = data;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async create() {
      try {
        this.loading = true;

        const { description, type, parent_id } = this;

        let params = { description, type, parent_id };

        const response = await api.post(
          "/rest-home/financial/configuration/profit-cost-center",
          params
        );

        const { error, errors, message, id } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide("create");

          this.$emit("success", id);

          this.description = "";
          this.type = "";
          this.parent_id = "";
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
